export default {"src":"/_next/static/media/time.66b7500c.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};